import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsappFab from "./components/WhatsappFab";

import Home from "./pages/Home";
import About from "./pages/About";
import Retailers from "./pages/Retailers";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-[#FAF6F0] text-[#4A3F35] min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/retailers" element={<Retailers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <WhatsappFab />
        <Toaster position="top-center" theme="light" />
      </BrowserRouter>
    </div>
  );
}

export default App;
